import styled from "styled-components";
import {
    BlockTitle,
    BadgeRh,
    InfoNoteGray,
    FieldGrid,
    Field,
    Req,
    OptLabel,
    TagGroup,
    Block,
    SInput,
    SPhoneInputStyle,
    BlockFrozen,
    BadgeFrozen,
} from "../index";
import { Controller, useFormContext } from "react-hook-form";

export default function BlockIdentite() {
    const { control } = useFormContext();

    return (
        <BlockFrozen>
            <BlockTitle>
                Identité
                <BadgeRh>Pré-rempli par les RH</BadgeRh>
                <BadgeFrozen>
                    🔒 Champs obligatoires non modifiables
                </BadgeFrozen>
            </BlockTitle>

            <InfoNoteGray>
                Les champs pré-remplis par votre responsable RH apparaissent en
                grisé et ne sont pas modifiables. Les champs laissés vides sont
                à compléter par vous.
            </InfoNoteGray>

            <div style={{ marginBottom: 12 }}>
                <CiviliteLabel>Civilité</CiviliteLabel>
                <Controller
                    control={control}
                    render={({ field: { value } }) => {
                        return (
                            <TagGroup>
                                <FrozenTag key={2} $active={value === 2}>
                                    Madame
                                </FrozenTag>
                                <FrozenTag key={1} $active={value === 1}>
                                    Monsieur
                                </FrozenTag>
                                <FrozenTag key={3} $active={value === 3}>
                                    Non mentionné
                                </FrozenTag>
                            </TagGroup>
                        );
                    }}
                    name="identity.gender"
                />
            </div>

            <FieldGrid>
                <Field>
                    <label>
                        Prénom <Req>*</Req>
                        <OptLabel>(non modifiable)</OptLabel>
                    </label>
                    <Controller
                        control={control}
                        render={({ field: { value, name, ref } }) => {
                            return (
                                <SInput
                                    placeholder="Votre prénom"
                                    fluid
                                    ref={ref}
                                    name={name}
                                    value={value}
                                    disabled
                                />
                            );
                        }}
                        name="identity.first_name"
                    />
                </Field>
                <Field>
                    <label>
                        Nom <Req>*</Req>
                        <OptLabel>(non modifiable)</OptLabel>
                    </label>
                    <Controller
                        control={control}
                        render={({ field: { value, name, ref } }) => {
                            return (
                                <SInput
                                    placeholder="Votre nom"
                                    fluid
                                    ref={ref}
                                    name={name}
                                    value={value}
                                    disabled
                                />
                            );
                        }}
                        name="identity.last_name"
                    />
                </Field>
                <Field>
                    <label>
                        Nom d'usage
                        <OptLabel>(à compléter si souhaité)</OptLabel>
                    </label>

                    <Controller
                        control={control}
                        render={({ field: { onChange, value, name, ref } }) => {
                            return (
                                <SInput
                                    placeholder="Votre nom d'usage"
                                    fluid
                                    onChange={(e, i) => {
                                        onChange(i.value);
                                    }}
                                    ref={ref}
                                    name={name}
                                    value={value}
                                    disabled
                                />
                            );
                        }}
                        name="personal_infos.birth_name"
                    />
                </Field>
                <Field>
                    <label>
                        Adresse email personnelle <Req>*</Req>
                        <OptLabel>(non modifiable)</OptLabel>
                    </label>
                    <Controller
                        control={control}
                        render={({ field: { value, name, ref } }) => {
                            return (
                                <SInput
                                    placeholder="Votre adresse email personnelle"
                                    fluid
                                    ref={ref}
                                    name={name}
                                    value={value}
                                    disabled
                                />
                            );
                        }}
                        name="identity.email"
                    />
                </Field>
                <Field>
                    <label>Email professionnel </label>
                    <Controller
                        control={control}
                        render={({
                            field: { onChange, onBlur, value, name, ref },
                        }) => {
                            return (
                                <SInput
                                    placeholder="Votre adresse email professionnelle"
                                    fluid
                                    onChange={(e, i) => {
                                        onChange(i.value);
                                    }}
                                    ref={ref}
                                    name={name}
                                    value={value}
                                    disabled
                                />
                            );
                        }}
                        name="identity.email_pro"
                    />
                </Field>
                <Field>
                    <label>
                        Téléphone personnel <Req>*</Req>
                    </label>
                    <Controller
                        control={control}
                        render={({
                            field: { onChange, onBlur, value, name, ref },
                        }) => {
                            const formatValue = value.startsWith("+")
                                ? value
                                : "+" + value;
                            return (
                                <SPhoneInputStyle
                                    international
                                    countryCallingCodeEditable={false}
                                    defaultCountry={"CH"}
                                    value={formatValue}
                                    onChange={onChange}
                                    onBlur={onBlur}
                                    error={false}
                                    disabled
                                />
                            );
                        }}
                        name="identity.phone_perso"
                    />
                </Field>
            </FieldGrid>
        </BlockFrozen>
    );
}

const CiviliteLabel = styled.label`
    font-size: 11px;
    color: var(--text-sec);
    font-weight: 500;
    display: block;
    margin-bottom: 6px;
`;

const FrozenTag = styled.div`
    padding: 5px 14px;
    border-radius: 20px;
    font-size: 12px;
    border: 1px solid
        ${({ $active }) => ($active ? "var(--purple)" : "var(--border)")};
    background: ${({ $active }) =>
        $active ? "var(--purple)" : "var(--bg-secondary)"};
    color: ${({ $active }) => ($active ? "white" : "var(--text-sec)")};
    font-weight: 500;
    opacity: 0.55;
    cursor: not-allowed;
`;

const FrozenTagInactive = styled(FrozenTag)`
    opacity: 0.4;
`;
